import BaseViewModel from "./BaseViewModel";

class PageViewModel extends BaseViewModel {

	// FormElements: Array<BaseViewModel> = [];.
	PageElements: Array<BaseViewModel> = [];
	PageIndex?: number;

	Validate = () => {
		let valid = true;
		for (var i = 0; i < this.PageElements.length; i++) {
			valid = this.PageElements[i].Validate() && valid;
		}
		return valid;
	};

	//SimpleFormat
	override getSimpleFormatXmlTagName = () => 'Form';

	override getSimpleFormatXmlOpen = ( pageId?: string ) => {
		let xml = '<' + this.getSimpleFormatXmlTagName() + ' idRef="page_' + pageId + '" title=""';
		return xml + '>';
	};

};

export default PageViewModel;
